<template>
  <div
    v-if="isBlurred"
    class="privacy-blur-overlay"
    role="status"
    aria-live="polite"
    @mousedown="onInteract"
    @keydown="onInteract"
    @touchstart="onInteract"
  >
    <div class="privacy-blur-banner">
      <EyeOff :size="20" />
      <span>Screen hidden for privacy — move mouse or press a key to continue</span>
    </div>
  </div>
</template>

<script setup>
import { EyeOff } from 'lucide-vue-next'
import { usePrivacyBlur } from '@/composables/usePrivacyBlur'

const { isBlurred, wake } = usePrivacyBlur()

function onInteract() {
  wake()
}
</script>

<style scoped>
.privacy-blur-overlay {
  position: fixed;
  inset: 0;
  z-index: 9998;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 1.5rem;
  pointer-events: none;
}

.privacy-blur-banner {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.65rem 1rem;
  background: rgba(44, 62, 80, 0.92);
  color: #fff;
  border-radius: 8px;
  font-size: 0.9rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  pointer-events: auto;
  cursor: default;
}

body.privacy-blur-full .privacy-blur-overlay {
  pointer-events: auto;
  align-items: center;
  padding-top: 0;
}
</style>
